/** The canvas font: the serif face `styles.css` self-hosts (400 only; no italic is loaded). */
const SIGNATURE_FONT = '44px "Libre Caslon Text", Georgia, serif';
const CANVAS_WIDTH = 600;
const CANVAS_HEIGHT = 150;
const HORIZONTAL_PADDING = 24;
/** The drawn pad's stroke color, so a typed and a drawn signature render alike. */
const INK = "#0f172a";

/**
 * Render a typed name as a PNG signature image, returned as bare base64
 * without the `data:` prefix.
 *
 * The sign endpoints accept only `signaturePngBase64` (they reject anything
 * that is not a PNG), so the typed-name alternative to the drawing pad
 * produces the same kind of image client-side and the wire contract is
 * unchanged. The font is awaited first where the Font Loading API exists, so
 * the canvas never paints the fallback face; a long name shrinks to fit the
 * fixed width instead of clipping. Returns "" when the browser has no 2d
 * canvas.
 */
export async function typedSignaturePngBase64(name: string): Promise<string> {
  if ("fonts" in document) {
    try {
      await document.fonts.load(SIGNATURE_FONT);
    } catch {
      // Draw with whatever face is available.
    }
  }
  const canvas = document.createElement("canvas");
  canvas.width = CANVAS_WIDTH;
  canvas.height = CANVAS_HEIGHT;
  const ctx = canvas.getContext("2d");
  if (!ctx) return "";
  ctx.font = SIGNATURE_FONT;
  ctx.fillStyle = INK;
  ctx.textBaseline = "middle";
  const maxWidth = CANVAS_WIDTH - HORIZONTAL_PADDING * 2;
  ctx.fillText(name, HORIZONTAL_PADDING, CANVAS_HEIGHT / 2, maxWidth);
  const dataUrl = canvas.toDataURL("image/png");
  const comma = dataUrl.indexOf(",");
  return comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
}
